import "../Login/Login.css";
import React, { useEffect, useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from "bootstrap";
import name from "../../images/name.svg";
import lock from "../../images/lock.svg";
import emailIcon from "../../images/email.svg";
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa6";
import Signup from "../Signup/Signup";

function Login({ signFun, closeModal }) {
  const [pass, setPass] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState(null);




  const [loginTog, setLoginTog] = useState(true);
  const [signTog, setSignTog] = useState(false);

  const showingLogin = () => {

    setSignTog(!signTog)
    

    console.log(signTog, loginTog)

  }

  const showingSign = () => {

    setLoginTog(!signTog)
    signFun(signTog)
    console.log(signTog, "Lolg")

  }




  useEffect(() => {
    const modalElement = document.getElementById("exampleModalLOGIN");
    if (modalElement) {
      const modal = new Modal(modalElement);
      modal.show();
    }
  }, []);




  return (

    <div className="modal fade login-modal show d-block">
    <div className="modal-dialog login-dialog">
      <div className="modal-content login-content-div">
        <div className="modal-header login-header-div">
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <h5 className="modal-title login-title">Log In</h5>
        <p className="signup-desc">
          Not a member yet? Create a free profile by taking our personality test or entering your result yourself.
        </p>

        <div className="modal-body login-body">
          <form>
            <div className="mb-3 login-email">
              <label className="col-form-label">Email address</label>
              <input type="email" className="form-control" required />
            </div>

            <div className="mb-3 login-confirm">
              <label className="col-form-label">Password</label>
              <input type="password" className="form-control" required />
            </div>

            <div className="mb-3 login-submit">
              <input type="submit" value="Login" className="form-control" />
            </div>
          </form>

          <a className="login-last-cont" >
            Don't Have an Account? <span onClick={() => showingSign()} style={{ cursor: "pointer" }} >Sign Up</span>
          </a>
        </div>
      </div>
    </div>

    {/* {signTog && <Signup triggerSign={signTog} />} */}
  </div>

  );
}

export default Login;
